"use strict";
/*
 * Created on 03 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");
/**
 * Abstract representation of part of price release that can be approved or exported as the whole. This is typically category view
 * which is approved by user as the whole. Although the user approves whole category, there should be possibility to explicitly determine
 * products for which new price should be exported to external system.
 *
 * There is workflow bound to this composite entity. Workflow typically differs for different types of release workflow.
 *
 * @author JMe
 * @author Radek Beran
 */


var AbstractReleasePart =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractReleasePart, _DomainObject_1$Domai);

  /**
   * @param releaseId the internal id of release
   * @param productCategoryId category which this release part represents
   * @param approved date of release part (category) approval if category of release part was finally approved
   * @param firstApproval The same as before. However, only the first date of approval is saved in case of subsequent release re-opening.
   * @param approvedByUserId user id (who has been approved categoryPart)
   * @param approvedByUserName name of user who approved category part
   * @param cmDeadlineMissed true if CM approval was in delay - CM deadline was missed, higher role must approve the prices instead
   * @param workflowCaseId id of workflow instance if workflow is already initiated
   * @param calcWorkflowCaseId
   * @param calcProgressMonitorId
   * @param validationResult business alerts on release part level
   * @param readonly true if all items in this category cannot be edited, repriced and were not exported
   */
  function AbstractReleasePart(releaseId, productCategoryId, approved, firstApproval, approvedByUserId, approvedByUserName, cmDeadlineMissed, workflowCaseId, calcWorkflowCaseId, calcProgressMonitorId, validationResult, readonly) {
    var _this;

    _classCallCheck(this, AbstractReleasePart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleasePart).call(this));
    _this.releaseId = releaseId;
    _this.productCategoryId = productCategoryId;
    _this.approved = approved;
    _this.firstApproval = firstApproval;
    _this.approvedByUserId = approvedByUserId;
    _this.approvedByUserName = approvedByUserName;
    _this.cmDeadlineMissed = cmDeadlineMissed;
    _this.workflowCaseId = workflowCaseId;
    _this.calcWorkflowCaseId = calcWorkflowCaseId;
    _this.calcProgressMonitorId = calcProgressMonitorId;
    _this.validationResult = validationResult;
    _this.readonly = readonly;
    return _this;
  }
  /**
   * Returns id of product category corresponding to release part level.
   * @param productCategoryIds List of product categories. The first one is lowest category, the last one is root.
   */


  _createClass(AbstractReleasePart, [{
    key: "withMessage",

    /**
     * Adds messages into release part (if not present yet). Returns updated copy of this release part.
     * @param message
     */
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
  }], [{
    key: "findReleasePartCategoryId",
    value: function findReleasePartCategoryId(productCategoryIds, releasePartCategoryLevel) {
      // LOG-3564 - some products have only 5 levels of categories
      if (productCategoryIds.size === 0) {
        return null;
      }

      if (productCategoryIds.size >= releasePartCategoryLevel) {
        var idx = productCategoryIds.size - releasePartCategoryLevel;
        return productCategoryIds.get(idx, null);
      } else {
        throw new Error("Cannot determine release part category. " + "Unexpected number of levels (".concat(productCategoryIds.size, ") in product categories: ").concat(productCategoryIds.join(',')));
      }
    }
    /**
     * Returns id of product category corresponding to category manager level.
     * @param productCategoryIds List of product categories. The first one is lowest category, the last one is root.
     */

  }, {
    key: "findCategoryManagerCategoryId",
    value: function findCategoryManagerCategoryId(productCategoryIds, categoryManagerLevel) {
      // LOG-3564 - some products have only 5 levels of categories
      if (productCategoryIds.size === 0) {
        return null;
      }

      if (productCategoryIds.size >= categoryManagerLevel) {
        var idx = productCategoryIds.size - categoryManagerLevel;
        return productCategoryIds.get(idx, null);
      } else {
        throw new Error("Cannot determine category manager category. " + "Unexpected number of levels (".concat(productCategoryIds.size, ") in product categories: ").concat(productCategoryIds.join(',')));
      }
    }
  }]);

  return AbstractReleasePart;
}(DomainObject_1.DomainObject);

exports.AbstractReleasePart = AbstractReleasePart;

AbstractReleasePart.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(AbstractReleasePart.name);
  return {
    releaseId: builder.str('releaseId'),
    productCategoryId: builder.str('productCategoryId'),
    approved: builder.opt(builder.date('approved', DateParser_1.DateParser.ISO_PATTERN)),
    firstApproval: builder.opt(builder.date('firstApproval', DateParser_1.DateParser.ISO_PATTERN)),
    approvedByUserId: builder.opt(builder.str('approvedByUserId')),
    approvedByUserName: builder.opt(builder.str('approvedByUserName')),
    cmDeadlineMissed: builder.bool('cmDeadlineMissed'),
    workflowCaseId: builder.opt(builder.str('workflowCaseId')),
    calcWorkflowCaseId: builder.opt(builder.str('calcWorkflowCaseId')),
    calcProgressMonitorId: builder.opt(builder.str('calcProgressMonitorId')),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    }),
    readonly: builder.bool('readonly')
  };
}();